export const buttonsCategory = 'buttons'
export const comboboxCategory = 'combobox'
export const datesCategory = 'dates'
export const inputsCategory = 'inputs'
export const layoutCategory = 'layout'
export const miscellaneousCategory = 'miscellaneous'
export const otherExtensionsCategory = 'otherExtensions'
export const overlaysCategory = 'overlays'
export const typographyCategory = 'typography'
